// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M20.4551 17.5439L23.6797 19L20.4551 20.4551L19 23.6797L17.5439 20.4551L14.3203 19L17.5439 17.5439L19 14.3203L20.4551 17.5439Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 13.2334C21.3844 12.9125 20.7115 12.686 20 12.5762V4H4V13.5859L9 8.58594L14.6152 14.2012C13.3152 15.3897 12.5 17.0997 12.5 19C12.5 20.0823 12.7655 21.1024 13.2334 22H2V2H22V13.2334Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16 5.25C17.5188 5.25 18.75 6.48122 18.75 8C18.75 9.51878 17.5188 10.75 16 10.75C14.4812 10.75 13.25 9.51878 13.25 8C13.25 6.48122 14.4812 5.25 16 5.25Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-ai-image-filled')
export default class AiImageFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-image-filled',
    }
  }
}
